import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LatLng } from 'leaflet';

import { constructionSiteIcon, MapMarkerComponent, plantIcon, QPointMapPolygon, QPointMapPolyline, vehicleLoadedIcon } from '../../../../projects/qpoint-maps/src/public_api';
import { MapComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map.component";
import { MapPolylineComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map-polyline/map-polyline.component";
import { MapPolygonComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map-polygon/map-polygon.component";

@Component({
    selector: 'app-map-tba-test',
    imports: [
        CommonModule,
        MapComponent,
        MapPolylineComponent,
        MapPolygonComponent,
        MapMarkerComponent
    ],
    templateUrl: './map-tba-test.component.html',
    styleUrls: ['./map-tba-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapTbaTestComponent {
  private truckPosition = new LatLng(46.54627000000001, 16.27279);

  zoomPosition: google.maps.ControlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
  mapTypePosition: google.maps.ControlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
  center = this.truckPosition;

  routeData: QPointMapPolyline = {
    type: 'LineString',
    coordinates: [
      [
        16.11388167,
        46.69407594
      ],
      [
        16.27279,
        46.54627000000001
      ],
      [
        16.22888167,
        46.50307594
      ]
    ]
  };
  siteFence: QPointMapPolygon = {
      type: 'Polygon',
      coordinates: [[
        [
          16.11388167,
          46.6945256
        ],
        [
          16.11446662,
          46.69430077
        ],
        [
          16.11446662,
          46.69385111
        ],
        [
          16.11388168,
          46.69362628
        ],
        [
          16.11329673,
          46.69385111
        ],
        [
          16.11329673,
          46.69430077
        ],
        [
          16.11388168,
          46.6945256
        ]
      ]]
    };
    plantFence: QPointMapPolygon = {
      type: 'Polygon',
      coordinates: [[
        [
          16.22888167,
          46.5035256
        ],
        [
          16.22946662,
          46.50330077
        ],
        [
          16.22946662,
          46.50285111
        ],
        [
          16.22888168,
          46.50262628
        ],
        [
          16.22829673,
          46.50285111
        ],
        [
          16.22829673,
          46.50330077
        ],
        [
          16.22888168,
          46.5035256
        ]
      ]]
    };

  siteMarkerOptions = { position: new LatLng(46.69407594, 16.11388167), icon: constructionSiteIcon() };
  plantMarkerOptions = { position: new LatLng(46.50307594, 16.22888167), icon: plantIcon() };
  currentTruckMarkerOptions = { position: this.truckPosition, icon: vehicleLoadedIcon() };

  onMapLoaded(event) {
    console.log('Map loaded', event);
  }

  onMapTypeChanged(mapType: string) {
    console.log('Map type changed', mapType);
  }

  onFitBoundsChanged(event) {
    console.log('Fit bounds changed', event);
  }
}
